import { render, staticRenderFns } from "./sizeTemplateManage.vue?vue&type=template&id=de4d9c5a"
import script from "./sizeTemplateManage.vue?vue&type=script&lang=js"
export * from "./sizeTemplateManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports